export const OPTION_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

export const BRAND_ACTION_COLOR = '#0337D8';

export const PODCAST_ACTIVE_BG = '#E9EEFC';
